<template>
  <div class="verification_pg pg_frm_popup verificaton_popup">
    <div class="pg_bg_layer">

      <div class="row">
        <div class="col-xl-1"></div>
        <div class="col-xl-10 login-user-section login_sec_box content_bx" @keydown.enter="login">

          <div class="modal-header">
            <div class="head_txt">Verifying your email</div>
          </div>

          <div class="modal-body">

            <div class="row mt-4" v-if="!showError && !showLoginInstruction">
              <div class="col-1"></div>
              <div class="col-10" style="text-align: center;">
                <p>Loading.... Please wait</p>
              </div>
            </div>

            <div class="row mt-4" v-if="showError">
              <div class="col-1"></div>
              <div class="col-10"  style="text-align: center;">
                <p>Oops! Something went is not right. <br/>
                  Please check your link again.</p>
              </div>
            </div>

            <div class="row mt-4" v-if="showLoginInstruction">
              <div class="col-1"></div>
              <div class="col-10" style="text-align: center;">
                <p>Your account is already setup. Please login to get started</p>
                <button class="btn btn-secondary btn-lg" @click="goToLoginPage()">Login</button>
              </div>
            </div>

          </div> <!-- .modal-body -->

        </div>
        <div class="col-xl-2"></div>
      </div>
      <div class="loading-spinner">
          <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
              <div class="text-center" style="color: #FFF">
                  <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
              </div>
          </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  // import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'verify',
    components: {
    },
    data: () => {
      return {
        eMail: '',
        verificationCode: '',
        cipCode: '',
        socCode: '',
        programCode: '',
        action: '',
        programType:'',
        password: '',
        showError: false,
        showLoginInstruction: false
      }
    },

    watch: {

    },

    computed: {
      ...mapState({
      })
    },

    mounted () {
      this.loadVerificationPage()

    },

    methods: {
      ...mapActions([
        'loadLoginUser',
        'loadVerifyUser',
        'setUserInfo',
        'loadLogDashboardActivity',
        'setTemporaryUser'
      ]),
      getParameterByName(name, url = window.location.href) {
          name = name.replace(/[\[\]]/g, '\\$&')
          let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
          let results = regex.exec(decodeURIComponent(url))
          if (!results || !results[2]) return ''
          return results[2].replace(/\+/g, ' ')
      },
      loadVerificationPage () {
        this.eMail = this.getParameterByName('email')
        this.cipCode = this.getParameterByName('cipCode')
        this.socCode = this.getParameterByName('socCode')
        this.programCode = this.getParameterByName('programCode')
        this.verificationCode = this.getParameterByName('verificationCode')
        this.action = this.getParameterByName('action')
        this.programType = this.getParameterByName('programType')
        if(!this.programType || this.programType.length == 0){
            this.programType = 'MAJOR'
        }
        this.verifyUser()
      },
      goToLoginPage () {
        return this.$router.push({ name: 'userLogout' })
      },
      async verifyUser () {
        let userObj = {
          'eMail': this.eMail,
          'password': this.verificationCode,
          'verificationCode': this.verificationCode
        }
        if (this.eMail.length < 1) {
          this.showError = true
          this.notifyFailure('Oops! Email is missing. Please try again by going back to the widget')
        } else if (this.verificationCode.length < 5) {
          this.showError = true
          this.notifyFailure('Verificaton Code cannot be fewer than 5 characters!')
        } else {
          this.showLoader()
          let response = await this.loadVerifyUser(userObj)
          let status = response.status
          let data = response.data
          if (status === 200) {
            if (data.setupComplete) {
              this.showLoginInstruction = true
            } else {
              this.setUserInfo(data)
              this.setTemporaryUser()
              // navigate To explore based on major
              this.$parent.isUserLoggedIn = true
              this.$parent.isServiceAvailable = true
              this.$parent.isVerify = false
              await this.loadLogDashboardActivity({action: 'verifyEmailId', page: 'verify', link: ''})
              if ((this.action === 'ExploreRegionalData' || this.action === 'OtherCompanies') && this.cipCode && this.programCode) {
                let url = '/programguide/' + this.cipCode + '/' + this.programCode + '/'+this.programType+'/careerProspects'
                return this.$router.push(url)
              } else if (this.action === 'OtherCareers' && this.cipCode && this.programCode) {
                let url = '/programguide/' + this.cipCode + '/' + this.programCode + '/'+this.programType+'/careers'
                return this.$router.push(url)
              }else if (this.action === 'MorePathways' && this.cipCode && this.programCode) {
                let url = '/programguide/' + this.cipCode + '/' + this.programCode + '/'+this.programType+'/relatedProgram'
                return this.$router.push(url)
              }else if (this.action === 'MoreCredentials' && this.cipCode && this.programCode) {
                let url = '/programguide/' + this.cipCode + '/' + this.programCode + '/'+this.programType+'/faq'
                return this.$router.push(url)
              }  else if ((this.action === 'FullCareerReport' || this.action === 'ThirdCareer') && this.socCode) {
                let url = '/career/' + this.socCode + '/careerProspects'
                return this.$router.push(url)
              } else {
                this.showError = true
                this.notifyFailure('Error: Something went wrong!')
              }
            }
          } else {
            this.showError = true
            this.notifyFailure('Error: Verificaton Code did not match!')
          }
          this.hideLoader()
        }
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>

<style scoped>
.color-white a {
  color: #ffffff;
}
.close_button {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/app/login/components/Verify.vue